import { useQuery } from '@tanstack/react-query';
import { useCurrentCompany } from './useCurrentCompany';
import { supabase } from '../lib/supabase';

/**
 * Hook to check if billing features are enabled for the current company
 * Returns true if billing is enabled, false otherwise
 */
export function useBillingFeatureToggle() {
  const { data: currentCompanyId } = useCurrentCompany();

  return useQuery<boolean>({
    queryKey: ['billingFeatureToggle', { companyId: currentCompanyId }],
    enabled: !!currentCompanyId,
    staleTime: 5 * 60 * 1000, // 5 minutes - feature toggles don't change often
    queryFn: async () => {
      if (!currentCompanyId) {
        return false;
      }

      const { data, error } = await supabase
        .from('companies')
        .select('enable_billing')
        .eq('id', currentCompanyId)
        .single();

      if (error) {
        // Default to false if we can't check (fail closed)
        return false;
      }

      return (data as unknown as { enable_billing: boolean | null })?.enable_billing ?? false;
    },
  });
}
